export enum NotificationTriggeredByTypeEnum {
  ShiftNeed = 'ShiftNeed',
  ShiftRequest = 'ShiftRequest',
  Shift = 'Shift',
  Payment = 'Payment'
}

export const NOTIFICATION_TRIGGERED_BY_TYPE_SHIFTS = [
  NotificationTriggeredByTypeEnum.ShiftNeed,
  NotificationTriggeredByTypeEnum.ShiftRequest,
  NotificationTriggeredByTypeEnum.Shift
];

// ── Push notification event types (data.type in FCM payloads) ──────────

export enum PushNotificationType {
  CorporatePayerRemoved = 'corporate_payer_removed',
  FacilityReinstated = 'facility_reinstated'
}
